import styled from 'styled-components';

export const BeerContainer = styled.div`
  margin-top: 30px;
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(240px, 280px));
  gap: 20px;
  background: transparent;
  height: auto;
  width: 100%;
`;
